(() => {
  'use strict';
  const configElement = document.getElementById('finks-accessibility-config');
  const config = configElement ? JSON.parse(configElement.textContent) : {};
  const videoWrapper = '.fnks-2025-multi-slider__video-wrapper, .fnks-2026-heading-video__video-wrapper';
  const videoPicture = '.fnks-2025-multi-slider__thumbnail, .fnks-2026-heading-video__thumbnail';
  const carouselWrapper = '.ss__carousel__prev-wrapper, .ss__carousel__next-wrapper';

  function repair() {
    document.querySelectorAll('.acsb-trigger[role="button"]').forEach((trigger) => {
      if (!trigger.getAttribute('aria-label') && !trigger.getAttribute('aria-labelledby') && config.accessibilityOptions) {
        trigger.setAttribute('aria-label', config.accessibilityOptions);
      }
    });
    document.querySelectorAll('a[href="#acsbContent"]').forEach((link) => {
      if (!document.getElementById('acsbContent') && document.getElementById('MainContent')) {
        link.setAttribute('href', '#MainContent');
      }
    });
    document.querySelectorAll('.fnks-2025-shape-tabs__panel[aria-labelledby]').forEach((panel) => {
      if (panel.getAttribute('role') !== 'tabpanel') panel.setAttribute('role', 'tabpanel');
    });
    document.querySelectorAll('.contact-map-cards-v9 .v9-states, .contact-map-cards-v9 .v9-filters').forEach((group) => {
      if (group.getAttribute('role') !== 'group') group.setAttribute('role', 'group');
      group.querySelectorAll('button[role="tab"]').forEach((button) => button.removeAttribute('role'));
    });
    document.querySelectorAll(videoWrapper + ', ' + videoPicture).forEach((element) => {
      if (element.getAttribute('role') === 'button') element.removeAttribute('role');
      if (element.hasAttribute('tabindex')) element.removeAttribute('tabindex');
      if (element.hasAttribute('aria-label')) element.removeAttribute('aria-label');
    });
    document.querySelectorAll(carouselWrapper).forEach((wrapper) => {
      if (!wrapper.querySelector('.ss__carousel__prev[role="button"], .ss__carousel__next[role="button"], button')) return;
      if (wrapper.getAttribute('role') === 'button') wrapper.removeAttribute('role');
      if (wrapper.hasAttribute('tabindex')) wrapper.removeAttribute('tabindex');
    });
    document.querySelectorAll('div.product-single__thumbnails[role="list"] > .slick-list, div.product-single__thumbnails[role="list"] .slick-track').forEach((wrapper) => {
      if (wrapper.getAttribute('role') !== 'presentation') wrapper.setAttribute('role', 'presentation');
    });
    document.querySelectorAll('div.product-single__thumbnails[role="list"] .product-single__thumbnails-item').forEach((item) => {
      if (item.getAttribute('role') !== 'listitem') item.setAttribute('role', 'listitem');
    });
    document.querySelectorAll('.wishlist-engine[role="button"]').forEach((wrapper) => {
      if (!wrapper.querySelector('button, a[href], [role="button"][tabindex="0"]')) return;
      wrapper.removeAttribute('role');
      wrapper.removeAttribute('tabindex');
      wrapper.removeAttribute('aria-label');
    });
    document.querySelectorAll('.yotpo button.yotpo-default-button[role="tab"]').forEach((button) => {
      if (!/^write-(review|question)-/.test(button.getAttribute('aria-controls') || '')) return;
      button.removeAttribute('role');
      button.removeAttribute('aria-selected');
    });
    document.querySelectorAll('.branded-specs__table table[role="presentation"]').forEach((table) => {
      table.removeAttribute('role');
    });
    document.querySelectorAll('div[data-finks-klaviyo-tracking][role="main"]').forEach((tracker) => {
      tracker.removeAttribute('role');
    });
  }

  function start() {
    repair();
    let pending = false;
    const observer = new MutationObserver((records) => {
      const relevant = records.some((record) => record.type === 'childList' || record.target.matches(
        '.acsb-trigger, a[href="#acsbContent"], .fnks-2025-shape-tabs__panel, .v9-states, .v9-filters, .v9-state, .v9-chip, .product-single__thumbnails-item, .wishlist-engine, .yotpo button.yotpo-default-button, .branded-specs__table table, div[data-finks-klaviyo-tracking], ' + videoWrapper + ', ' + videoPicture + ', ' + carouselWrapper
      ));
      if (!relevant || pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        repair();
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'tabindex', 'aria-label', 'aria-labelledby', 'href']
    });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#MainContent"]');
    if (!link) return;
    const main = document.getElementById('MainContent');
    if (main) main.focus({ preventScroll: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
